import {
  ENTITY_STATUS,
  EntityStatus,
  SOURCE_FIELD,
  SourceField,
} from "./brandOverview.types";
import { TagColorType } from "components/DesignSystem/Tag/Tag";
import { EntityStatusType } from "types/Models/entity";

// ---- animation timings ----
export const CARD_STAGGER_SEC = 0.12;
// duration of ONE half of the panel flip (0→±90 exit, then ∓90→0 enter)
export const FLIP_HALF_SEC = 0.2;

// ---- status → label + tag colour ----
export const STATUS_LABEL: Record<EntityStatus, string> = {
  [ENTITY_STATUS.ACTIVE]: "Active",
  [ENTITY_STATUS.PRE_INCORPORATED]: "Preincorporated",
  [ENTITY_STATUS.DISSOLVED]: "Dissolved",
};

export const STATUS_TAG_TYPE: Record<EntityStatus, TagColorType> = {
  [ENTITY_STATUS.ACTIVE]: "green",
  [ENTITY_STATUS.PRE_INCORPORATED]: "orange",
  [ENTITY_STATUS.DISSOLVED]: "red",
};

// bridges our status enum to the legacy EntityStatusSelect dropdown values
export const STATUS_TO_LEGACY: Record<EntityStatus, EntityStatusType> = {
  [ENTITY_STATUS.ACTIVE]: "ACTIVE",
  [ENTITY_STATUS.PRE_INCORPORATED]: "PRE_INCORPORATED",
  [ENTITY_STATUS.DISSOLVED]: "DISSOLVED",
};

// ---- source document each parsed field is linked to ----
export const FIELD_SOURCE_DOC: Record<SourceField, string> = {
  [SOURCE_FIELD.DATE_OF_INCORPORATION]: "Certificate of Incorporation",
  [SOURCE_FIELD.ENTITY_TYPE]: "Certificate of Incorporation",
  [SOURCE_FIELD.EIN]: "EIN confirmation letter (CP-575)",
  [SOURCE_FIELD.SHARES]: "Cap table",
};

// value rendered when a parsed field has no data
export const EMPTY_FIELD = "—";

// ---- related-entity relation semantics (from getGroupReviewDetails) ----
export const RELATION_PARENT = "parent";
export const RELATION_SUBSIDIARY = "subsidiary";

// ---- labels for the missing-details derivation ----
export const MISSING_LABEL = {
  EIN: "EIN number",
  DATE_OF_INCORPORATION: "Date of incorporation",
  STATES: "States of registration",
} as const;
